import { UnsupportedOperationError } from '../sdk/errors';
import { EncryptionKeysStore } from './encryption-keys-store';
export class EncryptionKeysProvider {
    static create(delegate, encryptionKeysStore = EncryptionKeysStore.createInMemory()) {
        return new CachedEncryptionKeysProvider(delegate, encryptionKeysStore);
    }
}
class CachedEncryptionKeysProvider extends EncryptionKeysProvider {
    constructor(delegate, encryptionKeysStore) {
        super();
        this.delegate = delegate;
        this.encryptionKeysStore = encryptionKeysStore;
        this.delegateGetPromises = {};
    }
    isAvailable() {
        return this.delegate.isAvailable();
    }
    async getFailSafe(subject) {
        const existingKeys = this.encryptionKeysStore.get(subject);
        if (existingKeys) {
            delete this.delegateGetPromises[subject.toString()];
            return existingKeys;
        }
        const existingDelegatePromise = this.delegateGetPromises[subject.toString()];
        if (existingDelegatePromise) {
            return existingDelegatePromise;
        }
        const delegatePromise = this.delegate
            .getFailSafe(subject)
            .then((it) => it && this.encryptionKeysStore.save(subject, it));
        // delete promise to refetch the token in case of failure
        delegatePromise.catch(() => {
            delete this.delegateGetPromises[subject.toString()];
        });
        this.delegateGetPromises[subject.toString()] = delegatePromise;
        return delegatePromise;
    }
    async getFailFast(subject) {
        return this.getFailSafe(subject).then((keys) => {
            if (!keys) {
                throw new UnsupportedOperationError('Encryption not supported', 'Wallet does not support encryption, please use wallet-adapter that supports diffieHellman() operation.');
            }
            return keys;
        });
    }
}
//# sourceMappingURL=encryption-keys-provider.js.map